<template>
  <v-container>
    <v-slide-x-reverse-transition mode="out-in">
      <v-card>
        <v-card-title>
          Skills
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="skills"
          :items-per-page="100"
          :search="search"
          class="elevation-1"
        ></v-data-table>
      </v-card>
    </v-slide-x-reverse-transition>
  </v-container>
</template>

<script>

export default {
  name: 'home',
  data: () => ({
    search: '',
    headers: [
      { text: 'Skill', value: 'skill' },
      { text: 'Type', value: 'type' },
      { text: 'Experience (years)', value: 'experience' }
    ],
    skills: [
      {
        skill: 'C',
        type: 'Programming Language',
        experience: 5
      },
      {
        skill: 'C++',
        type: 'Programming Language',
        experience: 5
      },
      {
        skill: 'C#',
        type: 'Programming Language',
        experience: 3.5
      },
      {
        skill: 'GLSL / HLSL',
        type: 'Programming Language',
        experience: 3.5
      },
      {
        skill: 'Python',
        type: 'Programming Language',
        experience: 3.5
      },
      {
        skill: 'Java',
        type: 'Programming Language',
        experience: 4
      },
      {
        skill: 'Javascript',
        type: 'Programming Language',
        experience: 4
      },
      {
        skill: 'Rust',
        type: 'Programming Language',
        experience: 3
      },
      {
        skill: 'Unity',
        type: 'Game Engine',
        experience: 3.5
      },
      {
        skill: 'Unreal Engine',
        type: 'GameEngine',
        experience: 3.5
      },
      {
        skill: 'Game AI',
        type: 'Architecture',
        experience: 3
      },
      {
        skill: 'Vulkan',
        type: 'Graphics Library',
        experience: 2.5
      },
      {
        skill: 'OpenGL',
        type: 'Graphics Library',
        experience: 3
      },
      {
        skill: 'HTML / CSS',
        type: 'Markup Language',
        experience: 4
      },
      {
        skill: 'React / React Native',
        type: 'Front-End Framework',
        experience: 2.5
      },
      {
        skill: 'Vue',
        type: 'Front-End Framework',
        experience: 1
      },
      {
        skill: 'Machine Learning',
        type: 'Architecture',
        experience: 3
      },
      {
        skill: 'Pytorch',
        type: 'Machine Learning Library',
        experience: 2
      },
      {
        skill: 'Tensorflow',
        type: 'Machine Learning Library',
        experience: 2
      }
    ]
  }),
  methods: {
    goto (path) {
      this.$router.push(path)
    }
  }
}
</script>

<style scoped>
  .page-tile {
    transition: .15s;
  }
</style>
